module.exports = __webpack_public_path__ + "img/icon-ers.38263f6f.png";